import { useContext, useEffect, useRef } from 'react';
import { GlobalVarsContext } from '../../context/GlobalVarsProvider';

export const useEmitter = () => {
    const { onEmitter, offEmitter, emit } = useContext(GlobalVarsContext);
    const componentIdRef = useRef(Symbol());
    const emittedOnLoadEventsRef = useRef(new Set());
    const emittedEventsRef = useRef(new Set());
    const callbacksRef = useRef({});

    const onEvent = (event, callback) => {
        if (!emittedEventsRef.current.has(event)) {
            callbacksRef.current[event] = callback;
            onEmitter(event, componentIdRef.current, (data) => {
                callbacksRef.current[event]?.(data);
            });
            emittedEventsRef.current.add(event);
        } else {
            callbacksRef.current[event] = callback;
        }
    };

    const emitOnLoad = (event, data) => {
        if (!emittedOnLoadEventsRef.current.has(event)) {
            emit(event, data);
            emittedOnLoadEventsRef.current.add(event);
        }
    };

    useEffect(() => {
        return () => {
            offEmitter(componentIdRef.current);
            emittedEventsRef.current = new Set();
        };
    }, []);

    return { onEmitter: onEvent, emit, emitOnLoad };
};
